import React, { useRef, useEffect } from 'react';

const slides = [
  {
    img: "https://images.unsplash.com/photo-1483985988355-763728e1935b?q=80&w=1600&auto=format",
    badge: "NEW COLLECTION",
    title: "Elevate Your Everyday Style",
    desc: "Curated fits, premium fabrics, effortless vibes. Up to 60% off.",
    cta1: "Shop Women",
    cta2: "Shop Men",
  },
  {
    img: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?q=80&w=1600&auto=format",
    badge: "LIMITED DROP",
    title: "Streetwear Meets Luxury",
    desc: "Oversized silhouettes, bold prints, zero compromise.",
    cta1: "Explore Drop",
  },
];

export default function HeroSlider() {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = React.useState(0);

  const nextSlide = () => {
    const next = (currentSlide + 1) % slides.length;
    setCurrentSlide(next);
    sliderRef.current?.scrollTo({ left: sliderRef.current.clientWidth * next, behavior: 'smooth' });
  };

  const prevSlide = () => {
    const prev = (currentSlide - 1 + slides.length) % slides.length;
    setCurrentSlide(prev);
    sliderRef.current?.scrollTo({ left: sliderRef.current.clientWidth * prev, behavior: 'smooth' });
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 6000);
    return () => clearInterval(interval);
  }, [currentSlide]);

  const handleScroll = () => {
    if (sliderRef.current) {
      const index = Math.round(sliderRef.current.scrollLeft / sliderRef.current.clientWidth);
      setCurrentSlide(index);
    }
  };

  return (
    <div className="relative rounded-[28px] overflow-hidden bg-slate-900 min-h-[420px] lg:min-h-[520px]">
      <div 
        ref={sliderRef}
        className="slider flex overflow-x-auto no-scrollbar h-full snap-x snap-mandatory"
        onScroll={handleScroll}
      >
        {slides.map((slide, idx) => (
          <div key={idx} className="min-w-full h-full relative">
            <img src={slide.img} className="absolute inset-0 w-full h-full object-cover" alt="" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent"></div>
            <div className="relative z-10 h-full flex flex-col justify-end p-8 lg:p-12 text-white max-w-xl">
              <span className="inline-flex w-fit items-center gap-2 px-3 py-1 rounded-full bg-white/15 backdrop-blur text-xs font-semibold mb-4">
                {slide.badge}
              </span>
              <h1 className="font-display text-[42px] lg:text-[56px] leading-[1.05]">{slide.title}</h1>
              <p className="mt-3 text-white/80 text-[15px]">{slide.desc}</p>
              <div className="mt-6 flex gap-3">
                <a href="#shop" className="px-5 h-12 grid place-items-center rounded-2xl bg-white text-slate-900 font-semibold text-sm hover:translate-y-[-1px] transition">
                  {slide.cta1}
                </a>
                {slide.cta2 && (
                  <a href="#shop" className="px-5 h-12 grid place-items-center rounded-2xl bg-white/10 backdrop-blur border border-white/20 text-white font-semibold text-sm hover:bg-white/20 transition">
                    {slide.cta2}
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="absolute bottom-5 right-5 flex gap-2">
        <button onClick={prevSlide} className="w-10 h-10 grid place-items-center rounded-full bg-white/15 backdrop-blur text-white hover:bg-white/25">
          <i className="ri-arrow-left-s-line text-2xl"></i>
        </button>
        <button onClick={nextSlide} className="w-10 h-10 grid place-items-center rounded-full bg-white/15 backdrop-blur text-white hover:bg-white/25">
          <i className="ri-arrow-right-s-line text-2xl"></i>
        </button>
      </div>
    </div>
  );
}